/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowUp
} from '@fortawesome/free-solid-svg-icons';
import { PlusOutlined } from '@ant-design/icons';
import { ADMIN_PRODUCTS_ADD } from 'constants/routes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter, useHistory } from 'react-router-dom';
import CustomTableFilter from './CustomTableFilter';

const CustomTable = ({ tableInstance, title, paragraph, button }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setGlobalFilter,
    state: { pageIndex, globalFilter }
  } = tableInstance;

  const { t } = useTranslation();
  const history = useHistory();

  return (
    <>
      <div className="product-admin-header" style={{ width: '100%' }}>
        <h3 className="product-admin-header-title">{title}</h3>
        {button && (
          <button
            style={{ marginRight: '2rem' }}
            className="button button-small"
            onClick={() => history.push(ADMIN_PRODUCTS_ADD)}
            type="button"
          >
            <PlusOutlined />
            &nbsp; {t('buttonNew')}
          </button>
        )}
        <CustomTableFilter filter={globalFilter} setFilter={setGlobalFilter} />
      </div>
      {paragraph && (
        <div className="product-admin-subheader">
          <span>{paragraph}</span>
        </div>
      )}
      {page.length !== 0 && (
        <>
          <table {...getTableProps()} style={{ width: '100%' }}>
            <thead className="product-admin-items">
              {headerGroups.map((headerGroup) => {
                return (
                  <tr
                    className="grid grid-product grid-count-6"
                    {...headerGroup.getHeaderGroupProps()}
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        className={`text-overflow-ellipsis-table ${
                          column.id !== 'col1' && 'grid-col-onlydesktop'
                        }`}
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {}
                        <div className="grid-col">
                          <h5>
                            {column.render('Header')}
                            <span>
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <FontAwesomeIcon
                                    style={{ marginLeft: '5px' }}
                                    icon={faArrowDown}
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    style={{ marginLeft: '5px' }}
                                    icon={faArrowUp}
                                  />
                                )
                              ) : (
                                ''
                              )}
                            </span>
                          </h5>
                        </div>
                      </th>
                    ))}
                  </tr>
                );
              })}
            </thead>
            <tbody {...getTableBodyProps()} className="product-admin-items">
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className="grid-admin grid-count-6 item item-user"
                  >
                    {row.cells.map((cell) => {
                      return (
                        <td
                          className={`text-overflow-ellipsis-table ${
                            (typeof cell.value === 'string' ||
                              cell.value instanceof Date) &&
                            'grid-col-onlydesktop'
                          }`}
                          style={{ margin: 'auto' }}
                          {...cell.getCellProps()}
                        >
                          {cell.value instanceof Date
                            ? cell.value.toLocaleDateString()
                            : cell.value}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="pagination">
            <button
              type="button"
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              <FontAwesomeIcon icon={faAngleDoubleLeft} />
            </button>{' '}
            <button
              type="button"
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>{' '}
            <button
              type="button"
              onClick={() => nextPage()}
              disabled={!canNextPage}
            >
              <FontAwesomeIcon icon={faAngleRight} />
            </button>{' '}
            <button
              type="button"
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              <FontAwesomeIcon icon={faAngleDoubleRight} />
            </button>{' '}
            <span>
              <strong>
                {pageIndex + 1} / {pageOptions.length}
              </strong>{' '}
            </span>
          </div>
        </>
      )}
    </>
  );
};

export default withRouter(CustomTable);
